import React, { useEffect, useState } from "react";
import SectionTitle from "../components/SectionTitle";
import { MdSearch } from "react-icons/md";
import ProjectItem from "../components/ProjectItem";
import ProjectInfo from "../assets/data/projects";
import ParaText from "../components/ParaText";

export default function Project() {
  const [searchText, setSearchText] = useState("");
  const [projectData, setProjectData] = useState(ProjectInfo);

  useEffect(() => {
    if (searchText === "") return;
    setProjectData(() =>
      ProjectInfo.filter((item) =>
        item.name.toLowerCase().match(searchText.toLowerCase())
      )
    );
  }, [searchText]);

  function handleChange(e) {
    e.preventDefault();
    setSearchText(e.target.value);
    if (!e.target.value.length > 0) {
      setProjectData(ProjectInfo);
    }
  }
  return (
    <div className="container">
      <div className="projectTitle__wrapper">
        <SectionTitle
          className="section-title"
          subheading="Some Of My Recent Works"
          heading="Projects"
        />
        <div className="projects__searchBar">
          <form action="">
            <input
              type="text"
              value={searchText}
              onChange={handleChange}
              placeholder="Project Name"
            />
            <MdSearch className="searchIcon" />
          </form>
        </div>
        <div className="projects__allItems__wrapper">
          {projectData.map((item) => (
            <ProjectItem
              key={item.id}
              title={item.name}
              desc={item.desc}
              img={item.img}
              href={item.href}
            />
          ))}
        </div>
        <ParaText className="aboutsection__paraText">
          <a
            style={{
              textDecoration: "none",
              color: "#242443",
              fontWeight: 500,
              textAlign: "center",
            }}
            href="https://github.com/ajibade3210"
          >
            <h2> Click Here For More</h2>
          </a>
        </ParaText>
      </div>
    </div>
  );
}
